

<template>
  <div class="home">
   
      <menus class="site-header" showTitle="true" />
    
  <section class="home-about">
    <div class="row column large-9 xlarge-6 xxlarge-4">
      <h2 class="section-title">Quick Introduction</h2>
      <p class="content">
        Fishing is a passion. In today's fast paced world, people need to find a moment of solice and discover their inner self... well not with Elson Outdoors. At EO, we put our customers on fish, big fish, and target specific regions during different times of year. If you are looking for the exhilerating hunt for trophy fish, please feel free to book a trip with us!
      </p>
    </div>

    <div class="row medium-up-2 large-up-5">
      <div class="column">
        <div class="home-about-block">
          <h3 class="title icon-success">Prespawn Walleyes</h3>
          <p class="content">They will not get any bigger than the day or two before these big girls head to spawn. Early Spring is lights out!</p>
        </div>
      </div>
      
      <div class="column">
        <div class="home-about-block">
          <h3 class="title icon-download">Trolling Walleyes</h3>
          <p class="content">Late season walleye action goes strong from early Fall until ice takes hold on Midwestern lakes.</p>
        </div>
      </div>

      <div class="column">
        <div class="home-about-block">
          <h3 class="title icon-unicorn">Fall Musky</h3>
          <p class="content">It can take some time, but Midwest lakes produce the largest muskies consistently in the late Fall.</p>
        </div>
      </div>
      
      <div class="column">
        <div class="home-about-block">
          <h3 class="title icon-winner">Prehistoric Beasts</h3>
          <p class="content">Elson Outdoors does that too. We will put you on perhaps the biggest fish you will ever catch!</p>
        </div>
      </div>

      <div class="column">
        <div class="home-about-block">
          <h3 class="title icon-price">Ice Walleyes</h3>
          <p class="content">Easily our favorite time of year, ice fishing across the Midwest and Canada keeps us busy when most folks are hunkering down.</p>
        </div>
      </div>
      
    </div>
  </section>

  <section class="home-story">
    <div class="row column large-9 xlarge-6 xxlarge-4">
      <h2 class="section-title">When We Are Not Fishing</h2>
      <p class="content">
         Elson Outdoors also offers technology consulting services for technology strategy, cloud computing, and smart manufacturing (aka Industry 4.0). If you know then you know.
      </p>
    </div>
  </section>

  <section class="home-sign-up">
    <div class="row column">

      <form onsubmit="javascript:void(0);">
        <input type="email" placeholder="Enter your email address">
        <button type="button">Submit</button>
      </form>

      <h2 class="section-title">Sign Up</h2>

      <p class="content">Elson Outdoors is growing! Enter your email to sign up for the latest news.</p>

      <!--<div class="apps">
        <a class="app-icon" href=""><img src="images/wr-home-apple.png"></a>
        <a class="app-icon" href=""><img src="images/wr-home-google.png"></a>
        <a class="app-icon" href=""><img src="images/wr-home-blackberry.png"></a>
        <a class="app-icon" href=""><img src="images/wr-home-Xiaomi.png"></a>
      </div>-->

      <div class="social">
        <a class="icon-fb" href="">Facebook</a>
        <a class="icon-tw" href="">Twitter</a>
        <a class="icon-ig" href="">Instagram</a>
        <a class="icon-wc" href="">Wechat</a>
        <a class="icon-wb" href="">Weibo</a>
      </div>
    </div>
  </section>

  <section class="home-quote">
    <div class="row column medium-8 xxlarge-6">
      <div class="quote-wrap">
        <div class="quote">
          “We booked a late season walleye outing on the St Croix River. EO provided us with a comfortable, professional and productive outing with over 20 walleyes boated in our three hour outing! Thanks EO!”
        </div>
        <div class="quoter">- Delighted Fisherman</div>
      </div>
    </div>
  </section>

  <section class="kraken-callout">
    <div class="row">
      <div class="columns medium-6 xxlarge-4 xxlarge-offset-2">
        <img src="images/eo/img4-med.jpg">
      </div>

      <div class="columns medium-6 xlarge-5 xxlarge-4">
        <h4 class="title">Your New Personal Best?</h4>
        <p class="content">
          Book a trip today to create your story.
        </p>
      </div>
    </div>
  </section>


    <footers />
  </div>
</template>

<script>
// @ is an alias to /src
import footers from '@/components/footer.vue'
import menu from '@/components/menu.vue'

export default {
  name: 'home',
  components: {
    footers: footers,
    menus: menu
  },
}

</script>
